/* eslint-disable consistent-return */
import React from 'react';
import PropTypes from 'prop-types';
import '../card_block/Card.css';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { useNavigate } from 'react-router-dom';

function ServicesItem(props) {
  const navigate = useNavigate();
  const { services } = props;
  const {
    id, image, name, quotes,
  } = services;

  const handleServices = (event) => {
    event.preventDefault();
    const { value } = event.target;
    switch (value) {
      case '1':
        return navigate('/services/technology');
      case '2':
        return navigate('/services/financial');
      case '3':
        return navigate('/services/management');
      case '4':
        return navigate('/services/business');
      case '5':
        return navigate('/services/duediligence');
      case '6':
        return navigate('/services/entrepreneureclub');
      default:
        navigate('/services');
    }
  };

  return (
    <Card key={id} border="primary" className="grid-item">
      <Card.Img variant="top" src={image} />
      <Card.Body>
        <Card.Title>
          {name}
        </Card.Title>
        <Card.Text>
          {quotes}
        </Card.Text>
      </Card.Body>
      <Button variant="primary" onClick={handleServices} value={id}>
        Enquire
      </Button>
    </Card>
  );
}
export default ServicesItem;

ServicesItem.propTypes = {
  services:
    PropTypes.objectOf(
      {
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        address: PropTypes.string.isRequired,
        mobile: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
      },
    ).isRequired,
};
